<template>
	<div class="integration-icon" :class="{ 'is-feature-type-integration': isFeatureType, 'hide-border': hideBorder }">
		<PuzzleSVG class="puzzle-icon-container" v-if="isFeatureType" />
		<SIconServices
			class="integration-name"
			:name="localIntegrationName"
			:height="size"
			:width="size"
			:aspect-ratio="1"
			:style="{ height: size + 'px', width: size + 'px', padding: localPadding + 'px' }"
		/>
	</div>
</template>

<script>
import SIconServices from '@/components/SIconServices';
import PuzzleSVG from './assets/PuzzleSVG';
import { FlowType } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'IntegrationIcon',
	components: {
		SIconServices,
		PuzzleSVG,
	},
	props: {
		integrationName: { type: String, required: true },
		integrationType: { type: String, default: null },
		size: { type: Number, default: 20 },
		padding: { type: Number, default: 4 },
		hideBorder: { type: Boolean, default: false },
	},
	computed: {
		isFeatureType() {
			return this.integrationType === FlowType.Experience;
		},
		localIntegrationName() {
			return this.isFeatureType && this.integrationName === FlowType.Tool ? 'notion' : this.integrationName;
		},
		localPadding() {
			return this.hideBorder ? 0 : this.padding;
		},
	},
};
</script>

<style scoped lang="scss">
.integration-icon {
	position: relative;

	.integration-name {
		position: relative;
		border: var(--primary-border);
		border-radius: 8px;
		background-color: #ffffff;
		box-shadow: 0 1px 2px #80899c4d;

		::v-deep {
			.v-image {
				height: 100%; // fix for old GMail icon being vertically miss-aligned to the top
			}
			svg {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}

	&.is-feature-type-integration {
		.puzzle-icon-container {
			position: absolute;
			top: -8px;
			right: -8px;
			z-index: 9;
		}
	}

	&.hide-border {
		.integration-name {
			border: none;
			box-shadow: none;
		}
	}
}
</style>
